import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ChevronDownIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.19693 9.10099L12.3989 13.325L16.6009 9.10099L17.8989 10.399L12.3989 15.899L6.89893 10.399L8.19693 9.10099Z'
                fill='currentColor'
            />
        </>
    ),
})

ChevronDownIcon.displayName = 'ChevronDownIcon'
